import { render, staticRenderFns } from "./iframeBlank.vue?vue&type=template&id=46ce732a&scoped=true&"
import script from "./iframeBlank.vue?vue&type=script&lang=js&"
export * from "./iframeBlank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ce732a",
  null
  
)

export default component.exports